import produce from "immer";
import {
  FETCH_BUNDLES,
  FETCH_BUNDLES_SUCCESS,
  FETCH_BUNDLES_FAILURE,
  TOGGLE_CONFIRM,
  TOGGLE_DELETE_PAYMENT,
  TOGGLE_CARD_MODAL,
  TOGGLE_SUB_MODAL,
  TOGGLE_CARD_LIST,
  SET_SUB_CART,
  RESET_SUB_CART,
  SUBSCRIBE,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBE_FAILURE,
  UPDATE_SUBSCRIBE,
  UPDATE_SUBSCRIBE_SUCCESS,
  UPDATE_SUBSCRIBE_FAILURE,
  GET_PAYMENT_LIST,
  GET_PAYMENT_LIST_SUCCESS,
  GET_PAYMENT_LIST_FAILURE,
  GET_HISTORY,
  GET_HISTORY_SUCCESS,
  GET_HISTORY_FAILURE,
  ADD_METHOD,
  ADD_METHOD_SUCCESS,
  ADD_METHOD_FAILURE,
  EDIT_METHOD,
  EDIT_METHOD_SUCCESS,
  EDIT_METHOD_FAILURE,
  GET_SUB_LIST,
  GET_SUB_LIST_SUCCESS,
  GET_SUB_LIST_FAILURE,
  DELETE_METHOD,
  DELETE_METHOD_SUCCESS,
  DELETE_METHOD_FAILURE,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_FAILURE,
  SET_DEFAULT,
  SET_DEFAULT_FAILURE,
  SET_DEFAULT_SUCCESS,
  REQ_DEMO,
  REQ_DEMO_SUCCESS,
  REQ_DEMO_FAILURE,
} from "./constants";

export const initialState = {
  isFetching: false,
  bundleList: [],
  toggleModal: { open: false },
  subCartData: null,
  isSubscribing: false,
  isUpdating: false,
  subscriptionData: {},
  isGettingList: false,
  paymentList: [],
  isGettingHistory: false,
  historyList: [],
  isAddingMethod: false,
  isEditingMethod: false,
  cardModal: false,
  isGettingSubList: false,
  subList: [],
  isDeletingMethod: false,
  deletePayModal: {
    open: false,
  },
  subModal: { open: false },
  listModal: { open: false },
  isRequestingDemo: false,
};

const BundlesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_BUNDLES:
        draft.isFetching = true;
        draft.bundleList = [];
        break;
      case FETCH_BUNDLES_SUCCESS:
        draft.isFetching = false;
        draft.bundleList = action.payload;
        break;
      case FETCH_BUNDLES_FAILURE:
        draft.isFetching = false;
        draft.bundleList = [];
        break;
      case TOGGLE_CONFIRM:
        draft.toggleModal = action.payload;
        break;
      case TOGGLE_DELETE_PAYMENT:
        draft.deletePayModal = action.payload;
        break;
      case TOGGLE_CARD_MODAL:
        draft.cardModal = action.payload;
        break;
      case TOGGLE_CARD_LIST:
        draft.listModal = action.payload;
        break;
      case SET_SUB_CART:
        draft.subCartData = action.payload;
        break;
      case RESET_SUB_CART:
        draft.subCartData = null;
        break;
      case SUBSCRIBE:
        draft.isSubscribing = true;
        draft.subscriptionData = {};
        break;
      case SUBSCRIBE_SUCCESS:
        draft.isSubscribing = false;
        draft.subscriptionData = action.payload;
        break;
      case SUBSCRIBE_FAILURE:
        draft.isSubscribing = false;
        draft.subscriptionData = {};
        break;
      case UPDATE_SUBSCRIBE:
        draft.isUpdating = true;
        break;
      case UPDATE_SUBSCRIBE_SUCCESS:
        draft.isUpdating = false;
        break;
      case UPDATE_SUBSCRIBE_FAILURE:
        draft.isUpdating = false;
        break;
      case GET_PAYMENT_LIST:
        draft.isGettingList = true;
        draft.paymentList = [];
        break;
      case GET_PAYMENT_LIST_SUCCESS:
        draft.isGettingList = false;
        draft.paymentList = action.payload;
        break;
      case GET_PAYMENT_LIST_FAILURE:
        draft.isGettingList = false;
        draft.paymentList = [];
        break;
      case GET_HISTORY:
        draft.isGettingHistory = true;
        draft.historyList = [];
        break;
      case GET_HISTORY_SUCCESS:
        draft.isGettingHistory = false;
        draft.historyList = action.payload;
        break;
      case GET_HISTORY_FAILURE:
        draft.isGettingHistory = false;
        draft.historyList = [];
        break;
      case ADD_METHOD:
        draft.isAddingMethod = true;
        break;
      case ADD_METHOD_SUCCESS:
        draft.isAddingMethod = false;
        break;
      case ADD_METHOD_FAILURE:
        draft.isAddingMethod = false;
        break;
      case EDIT_METHOD:
        draft.isEditingMethod = true;
        break;
      case EDIT_METHOD_SUCCESS:
        draft.isEditingMethod = false;
        break;
      case EDIT_METHOD_FAILURE:
        draft.isEditingMethod = false;
        break;
      case GET_SUB_LIST:
        draft.isGettingSubList = true;
        draft.subList = [];
        break;
      case GET_SUB_LIST_SUCCESS:
        draft.isGettingSubList = false;
        draft.subList = action.payload;
        break;
      case GET_SUB_LIST_FAILURE:
        draft.isGettingSubList = false;
        draft.subList = [];
        break;
      case DELETE_METHOD:
        draft.isDeletingMethod = true;
        break;
      case DELETE_METHOD_SUCCESS:
        draft.isDeletingMethod = false;
        break;
      case DELETE_METHOD_FAILURE:
        draft.isDeletingMethod = false;
        break;
      case TOGGLE_SUB_MODAL:
        draft.subModal = action.payload;
        break;
      case CANCEL_SUBSCRIPTION:
        draft.isDeletingMethod = true;
        break;
      case CANCEL_SUBSCRIPTION_SUCCESS:
        draft.isDeletingMethod = false;
        break;
      case CANCEL_SUBSCRIPTION_FAILURE:
        draft.isDeletingMethod = false;
        break;
      case SET_DEFAULT:
        draft.isSettingDefault = true;
        break;
      case SET_DEFAULT_SUCCESS:
        draft.isSettingDefault = false;
        break;
      case SET_DEFAULT_FAILURE:
        draft.isSettingDefault = false;
        break;

      case REQ_DEMO:
        draft.isRequestingDemo = true;
        break;
      case REQ_DEMO_SUCCESS:
        draft.isRequestingDemo = false;
        break;
      case REQ_DEMO_FAILURE:
        draft.isRequestingDemo = false;
        break;

      default:
        return state;
    }
  });

export default BundlesReducer;
